import React, { useState, useEffect, useRef,useMemo, forwardRef, useImperativeHandle } from 'react';
import { AppDispatch } from '../../redux/store';
import { useDispatch } from 'react-redux';
import XLS from '../../assets/images/xls.png';
import dateIcon from '../../assets/images/date-icon.png';
import { FaSearch } from "react-icons/fa";
import DatePicker from "react-datepicker";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";
import ExcelJS from 'exceljs';
import "react-datepicker/dist/react-datepicker.css";
import nexapi from '../../services/api';
import { useAppContext } from '../../context/appcontext';
import { toast } from "react-toastify";
import { fetchApplications } from '../../redux/slices/applicationsSlice';
import Select, { components } from 'react-select';
import defaultImage from "../../assets/images/default_user.jpg";
import { sortByKeyAsc } from "../../commonFunction";
import { useNavigate } from 'react-router-dom';
import { getTruncatedText,getDashboardMaxCharsDash } from "../../services/commonService"; // your utility
import $ from "jquery";
import localforage from "localforage";


// ✅ Import DataTables JS + CSS from correct package
import "datatables.net-dt/js/dataTables.dataTables";
import "datatables.net-dt/css/jquery.dataTables.css";
export interface DynamicTableRef {
  resetTab: (tab: string) => void;
}
interface DynamicTableProps {
  data: any;
  tabState: string;
  totalPage: number;
  recordsPerPage: number;
  searchQuery: string;
  handleChange: (event: React.ChangeEvent<HTMLSelectElement>) => void;
  handlePageChange: (pageNumber: number) => void;
  loading: boolean;
  isreason?: boolean;
  isRole?: boolean;
  isUser?: boolean;
  page?: string;
  fetchData: (filters: {}, page: number, numberOfRecord: number, userId: string, sortColumn?: string,
  sortOrder?: 'asc' | 'desc', tab?: string) => void; // <-- Add this
  redirect_url?:string;
  setFilters: React.Dispatch<React.SetStateAction<any>>;
  filters: any;
  sortColumn: string | null;  
  sortOrder: "asc" | "desc";
  companyId: string | null;
  setCompanyId: React.Dispatch<React.SetStateAction<string | null>>;
  onSort: (state: any) => void;
  keySort:string | null;
     company: string;
  setCompany: React.Dispatch<React.SetStateAction<string>>;
  dataCompanies: Application[];
  id:string;
  disableInitialFetch:boolean;

}
interface CustomDateInputProps extends React.InputHTMLAttributes<HTMLInputElement> {
  onClick?: () => void;
}

interface Application {
  id: string;
  name: string;
  email:string;
  image:string;
  tooltip: string;
  inDepthTooltipID: string;
}

type SubtypeGroup = {
  name: string;
  subtypes: {
    subtypeId: string;
    fieldName: string;
    tooltip?: string;
    inDepthTooltipID?: string;
  }[];
};
type SubtypeModel = {
  subtypeId: string;
  fieldName: string;
  tooltip?: string;
  inDepthTooltipID?: string;
};
interface userModel {
  id: string;
  name: string;
  email: string;
  Company: string;
  type: string;
  department: string;
}
const DynamicTable = forwardRef<DynamicTableRef, DynamicTableProps>(
  (
    {
      data,
      tabState,
      totalPage,
      recordsPerPage,
      handleChange,
      handlePageChange,
      loading,
      page,
      fetchData,
      redirect_url,
      setFilters,
      filters,
      sortColumn,
      sortOrder,
      companyId,
      setCompanyId,
      onSort,
      keySort,
      company,
      setCompany,
      id,
      disableInitialFetch
    },
    ref
  ) => {
  const currentPage = Number(page);
   const navigate = useNavigate();
   const dispatch = useDispatch<AppDispatch>();
  const { loggedinuser } = useAppContext();
  const userId = loggedinuser.id;
  const [searchQuery, setSearchQuery] = useState('');
  const [filteredData, setFilteredData] = useState(data);
  const [selectedDate, setSelectedDate] = useState<Date | null>(null);
  const [localSortColumn, setLocalSortColumn] = useState<string | null>(sortColumn); // Sync the sortColumn prop
  const [localSortOrder, setLocalSortOrder] = useState<'asc' | 'desc'>(sortOrder || 'asc'); // Sync the sortOrder prop
  const [toDate, setSelectedToDate] = useState<Date | null>(null);
const [inputRequesterValue, setInputRequesterValue] = useState("");
const [requestor, setRequestor] = useState("");
const [showSuggestions, setShowSuggestions] = useState(false);
const formatLocalDateTime = (d) => {
  if (!d) return "";

  // Automatically detect user's local timezone
  const userTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;

  return new Date(d)
    .toLocaleString("en-GB", {
      day: "2-digit",
      month: "short",
      year: "numeric",
      hour: "2-digit",
      minute: "2-digit",
      hour12: true,
      timeZone: userTimeZone, // dynamically applies user’s system timezone
    })
    .replace("Sept", "Sep")
    .replace("am", "AM")
    .replace("pm", "PM");
};

useEffect(() => {
  if (disableInitialFetch) return;
  fetchData(filters, Number(page), recordsPerPage, userId, sortColumn, sortOrder, tabState);
}, []);

useEffect(() => {
  const handleClickOutside = (event) => {
    const selectContainer = document.querySelector(".basic-single-select");
    if (selectContainer && !selectContainer.contains(event.target)) {
      setShowSuggestions(false);
    }
  };

  document.addEventListener("mousedown", handleClickOutside);
  return () => {
    document.removeEventListener("mousedown", handleClickOutside);
  };
}, []);
  useEffect(() => {
    const filtered = data.filter((row) =>
      Object.values(row).some((value) =>
        value && value.toString().toLowerCase().includes(searchQuery.toLowerCase())
      )
    );
    setFilteredData(filtered);
  }, [searchQuery, data]);
const tableRef = useRef<HTMLTableElement>(null);
const tableColumnWidths: Record<string, number[]> = {
  "tab-pending-approvals": [10, 10, 20, 20, 10, 30],
  "tab-resubmission": [10, 10, 15, 15, 30],
  "tab-drafts": [15, 15, 25, 45],
  "tab-myrequest": [10, 10, 20, 20, 10, 30],
  "tab-reviews": [10, 10, 10, 13, 15, 12, 30],
  "tab-actioned": [10, 10, 10, 10, 15, 10, 35],
  "tab-allrequests": [10, 10, 10, 10, 10, 10, 20, 20],
};

useEffect(() => {
  const table = tableRef.current;
  if (!table) return;

  const tableId = table.id;
  const headers = table.querySelectorAll<HTMLTableCellElement>("th");
  const widths = tableColumnWidths[tableId] || [];

  const resizeObserver = new ResizeObserver(() => {
    requestAnimationFrame(() => {
      const tableWidth = table.offsetWidth;

      headers.forEach((th, i) => {
        if (widths[i]) {
          // Convert % to px
          const newWidth = (widths[i] / 100) * tableWidth;
          th.style.width = `${newWidth}px`;
          th.style.whiteSpace = "nowrap";
        } else {
          th.style.width = ""; // fallback
        }
      });
    });
  });

  resizeObserver.observe(table);

  return () => resizeObserver.disconnect();
}, [filteredData]);


  const handleSearchClick = (tab: string) => {
    const inputElement = document.getElementById("search-input") as HTMLInputElement;
    const query = inputElement?.value.trim().toLowerCase();
    handleFilter(tab,query)
  };

  // Update local state when the sortColumn or sortOrder props change
    useEffect(() => {
    setLocalSortColumn(sortColumn);
    setLocalSortOrder(sortOrder || 'asc');
  }, [sortColumn, sortOrder]);

  // useEffect(() => {
  //   handlePageChange(currentPage);
  // }, [currentPage, handlePageChange]);

  // useEffect(() => {
  //   if (tabState) {
  //     handleReset(tabState);
  //   }
  // }, [tabState]);

  const handleSort = (column: string) => {
    const newSortOrder = localSortColumn === column && localSortOrder === "asc" ? "desc" : "asc";
    setLocalSortColumn(column);
    setLocalSortOrder(newSortOrder);
  
    // Notify parent to trigger fetch
    onSort({ column, order: newSortOrder });
  };

  const handlePageChangeLocal = (newPage: number) => {
    if (newPage !== currentPage) {
      handlePageChange(newPage);
    }
  };

  useEffect(() => {
    setSearchQuery('');
  }, [tabState]);
  
  const [isCollapsed, setIsCollapsed] = useState(true);
  const toggleCollapse = () => {
    setIsCollapsed(!isCollapsed);
  };

      // useEffect(() => {
        
      //       setIsCollapsed(true);
      //     }, [id]);
          
  const renderPageNumbers = (): (number | string)[] => {
    const pages: (number | string)[] = [];
  
    if (totalPage <= 5) {
      for (let i = 1; i <= totalPage; i++) pages.push(i);
    } else {
      if (currentPage <= 3) {
        pages.push(1, 2, 3, "...", totalPage);
      } else if (currentPage >= totalPage - 2) {
        pages.push(1, "...", totalPage - 2, totalPage - 1, totalPage);
      } else {
        pages.push(1, "...", currentPage - 1, currentPage, currentPage + 1, "...", totalPage);
      }
    }
  
    return pages;
  };
  
  const getHeading = () => {
    switch (tabState) {
      case 'drafts':
        return 'My Drafts';
      case 'myrequest':
        return 'My Requests';
      case 'reviews':
        return 'My Reviews';
      case 'actioned':
        return 'My Actioned Requests';
      case 'allrequests':
        return 'All Requests';
      case 'resubmission':
        return 'My Pending Resubmissions';
      default:
        return 'My Pending Approvals';
    }
  };

  const getMainHeading = () => {
    switch (tabState) {
      case 'drafts':
        return 'New Request';
      case 'myrequest':
        return 'Request Details';
      case 'reviews':
        return 'Request Details';
      case 'actioned':
        return 'Request Details';
      case 'allrequests':
        return 'Request Details';
      case 'resubmission':
        return 'My Pending Resubmission';
      default:
        return 'My Pending Approvals';
    }
  };

  
  const [applications, setApplications] = useState<Application[]>([]);
  const [applicationType, setApplicationType] = useState("");
  const [dataUser, setDataUser] = useState<userModel[]>([]);
  const [application, setapplication] = useState("");
  const [request, setRequest] = useState("");
  const [status, setStatus] = useState("");
  const [dataCompanies, setDataCompanies] = useState<Application[]>([]);
  useEffect(() => {
    const getApplications = async () => {
      const apps = await fetchAllApplications();
      setApplications(apps); // Set the fetched applications in state
    };
    getApplications();

    const getUsers = async () => {
      const user = await fetchUsers("00000000-0000-0000-0000-000000000000");

      setDataUser(user); // Set the fetched applications in state
      
    };
    getUsers();
    const getCompanies = async () => {
      const company = await fetchCompanies();

      setDataCompanies(company); // Set the fetched applications in state
    };
    getCompanies();

  }, []);
const [filteredOptions, setFilteredOptions] = useState([]);
  const options = useMemo(() => {
  if (!dataUser || dataUser.length === 0) return null;

  return dataUser.map((user) => ({
    value: user.id,
    label: user.name,
    email: user.email,
    image: defaultImage,
  }));
}, [dataUser]);

const [lastFilteredList, setLastFilteredList] = useState([]);
const [recentUsers, setRecentUsers] = useState([]);
const handleSearchRequestor = (searchText) => {
  if (searchText.length >= 3) {
    
    const filtered = options.filter(
      (opt) =>
        opt.label.toLowerCase().includes(searchText.toLowerCase()) ||
        opt.email.toLowerCase().includes(searchText.toLowerCase())
    );
    setFilteredOptions(filtered);
  } else if (searchText === "") {
    setFilteredOptions(recentUsers);  // Show last 5 users if no input
  } else {
    setFilteredOptions([]);
  }
};
const CustomSingleValue = (props) => {
  const { data, selectProps, setShowSuggestions, setInputRequesterValue, handleSearchRequestor } = props;

  return (
    <span title={`${data.label} (${data.email})`}
      style={{
        display: "flex",
        alignItems: "center",
        background: "rgb(204, 204, 204)",
        borderRadius: "9999px",
        gap: "6px",
        width: "100%",
        cursor: "default",
        position: "relative",
        marginBottom: "2px",
      }}
      onClick={(e) => e.stopPropagation()}
    >
      <img
        src={data.image || defaultImage}
        alt="user"
        style={{ width: 20, height: 20, borderRadius: "50%" }}
      />
      <span
        style={{
          maxWidth: 100,
          overflow: "hidden",
          textOverflow: "ellipsis",
          whiteSpace: "nowrap",
          color: "#000",
          fontSize: "12px",
        }}
        className="badge-name"
      >
        {data.label.length > 25 ? `${data.label.slice(0, 25)}...` : data.label}
      </span>
      <span
        onClick={(e) => {
          e.stopPropagation();
          const inputContainer = document.querySelector(".select__input-container") as HTMLElement | null;
          if (inputContainer) {
            inputContainer.style.height = "";
            inputContainer.style.paddingTop = "";
          }

          selectProps.onChange(null);
          setInputRequesterValue("");
          handleSearchRequestor("");
          setShowSuggestions(false);

          setTimeout(() => {
            const inputEl = document.querySelector(".select__input-container input") as HTMLInputElement | null;
            inputEl?.focus();
            setShowSuggestions(true);
          }, 50);
        }}
        style={{
          cursor: "pointer",
          fontWeight: "bold",
          right: "2px",
          display: "flex",
          alignItems: "center",
          width: 20,
          height: 20,
          color: "#888",
          padding: "2px 6px",
          borderRadius: "50%",
          fontSize: "12px",
          position: "absolute",
        }}
        className="badge-clear"
      >
        ×
      </span>
    </span>
  );
};

const MenuList = (props) => (
  <components.MenuList {...props}>
    <div style={{ padding: "0px 12px", fontSize: "12px", color: "rgb(26, 0, 93)", lineHeight: "40px" }}>
      Suggested People
    </div>
    <hr style={{ margin: "0 0px 6px" }} />
    {props.children}
  </components.MenuList>
);

const NoOptionsMessage = (props) => {
  const { selectProps } = props;
  const input = selectProps.inputValue || "";
  const shouldShow = input.length >= 3;

  return (
    <components.NoOptionsMessage {...props}>
      <div style={{ textAlign: "center", color: "#000", fontSize: "12px", lineHeight: "30px" }}>
        { "No results found"}
      </div>
    </components.NoOptionsMessage>
  );
};
  // const fetchUsers = async (): Promise<Application[]> => {
  //   try {

  //     const response = await nexapi.post(`User/GetUsers`);

  //     const data = response.data.data;
  //     return data.map((app: any) => ({
  //       id: app.id,
  //       name: app.displayName,
  //       email: app.mail,
  //     }));
  //   } catch (error) {
  //     console.error("Error fetching applications:", error);
  //     return [];
  //   }
  // };


const fetchUsers = async (userId: string): Promise<userModel[]> => {
  try {
    
    // 🟢 1️⃣ Try loading from cache
    const cachedDataRaw = await localforage.getItem<any[]>("UsersJson");
    let cachedData: userModel[] | null = null;

    if (cachedDataRaw && cachedDataRaw.length > 0) {
      // 🔄 Map cached data to userModel[]
      cachedData = cachedDataRaw
       .filter((app: any) => app.state === true).map((app: any) => ({
        id: app.id ?? app.id,
        name: app.name ?? app.displayName ?? "",
        email: app.email ?? app.mail ?? "",
        Company: app.Company ?? app.company_name ?? app.CompanyName ?? "",
        type: app.type ?? app.job_title ?? app.JobTitle ?? "",
        department: app.department ?? app.Department ?? ""
      }));

      console.log("✅ Loaded UsersJson from cache");
    }
    return cachedData;
  } catch (error) {
    console.error("❌ Error loading UsersJson:", error);
    return [];
  }
};

  const fetchCompanies = async (): Promise<Application[]> => {
    try {
      const response = await nexapi.post(`Company/GetAll?pagination=false`);
      const data = response.data.data;
      //console.log(data);
      var appdata = data.map((app: any) => ({
        id: app.id,
        name: app.companyCode,
      }));
      return sortByKeyAsc(appdata,"name");
    } catch (error) {
      console.error("Error fetching comapnies:", error);
      return [];
    }
  };

  const handleRequestChange = (e) => {
    setRequest(e.target.value);
  };
  const handleStatusChange = (e)=>{
    setStatus(e.target.value);
  }

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>, setter: React.Dispatch<React.SetStateAction<string>>) => {
    setSubid('')
    handleApplicationChange(e.target.value);
    setter(e.target.value);
    setapplication(e.target.value);
  };
const handleSubtype = (
  e: React.ChangeEvent<HTMLSelectElement | HTMLInputElement>,
  setter: React.Dispatch<React.SetStateAction<string>>
) => {
  const value = e.target.value || null;

  setter(value ?? "");      // keep your UI state
  setSubid(value);          // real subtypeId state

  const selected = subtype
    .flatMap(group => group.subtypes)
    .find(app => app.subtypeId === value);

  setSelectedSubtype(selected || null);
};

  const handleRequestor = (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>, setter: React.Dispatch<React.SetStateAction<string>>) => {

    setter(e.target.value);
    setRequestor(e.target.value)
  };
  const handleRequestorSingle = (selectedOption) => {
  if (selectedOption) {
    setRequestor(selectedOption.value);
  } else {
    setRequestor("");
  }
};

  const handleCompanies = (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>, setter: React.Dispatch<React.SetStateAction<string>>) => {
    setter(e.target.value);
    setCompany(e.target.value);// ✅ Updates the parent's state
    if(e.target.value=="0"){
       setCompanyId(null);
    }else{
    setCompanyId(e.target.value);
    }


    
  };


  const [errors, setErrors] = useState<{ [key: string]: string }>({});
    const [selectedTooltip, setSelectedTooltip] = useState("");
      const [selectedSubtype, setSelectedSubtype] = useState<SubtypeModel | null>(null);
        const [selectedAppLabel, setSelectedAppLabel] = useState<string>("");
  

   const fetchSubtype = async (id: string): Promise<SubtypeGroup[]> => {
    try {
      const response = await nexapi.get(
        `Subtype/SubtypeReqForm?id=${id}&userId=${userId}`
      );
      const data = response.data.data || [];
      
      return data.map((group: any) => ({
        name: group.name,
        subtypes: group.subtypes.map((sub: any) => ({
          subtypeId: sub.subtypeId,
          fieldName: sub.fieldName,
          tooltip: sub.hoverTooltip,
          inDepthTooltipID: sub.inDepthTooltipID,
        })),
      }));
    } catch (error) {
      console.error("Error fetching subtypes:", error);
      return [];
    }
  };
  const handleApplicationChange = async (value: string) => {
    if (value) {
      const subtypes = await fetchSubtype(value);
      setSubtypes(subtypes);
    } else {
      setSubtypes([]); // Reset if no value selected
    }
  };

  const fetchAllApplications = async (): Promise<Application[]> => {
    try {
      
      const response = await dispatch(fetchApplications({filters})).unwrap();
      const data = response?.applications;
      const apps = data.map((app: any) => ({
        id: app.id,
        name: app.title,
      }));

      return sortByKeyAsc(apps, "name");
    } catch (error) {
      console.error("Error fetching applications:", error);
      return [];
    }
  };
  const handleFilter = (tab: string,se:string) => {
    
    const inputElement = document.getElementById("search-input") as HTMLInputElement;
    const search = inputElement?.value.trim().toLowerCase();
    const filters = {
      requestID: request.trim() || null,
      applicationID: application || null,
      subtypeID: subid || null,
      requestorName: requestor || null,
      formAction: status || null,
      submittedDateFrom: selectedDate
        ? `${selectedDate.getFullYear()}-${String(selectedDate.getMonth() + 1).padStart(2, "0")}-${String(selectedDate.getDate()).padStart(2, "0")} 00:00:00`
        : null,
        submittedDateTo: toDate
        ? `${toDate.getFullYear()}-${String(toDate.getMonth() + 1).padStart(2, "0")}-${String(toDate.getDate()).padStart(2, "0")} 23:59:59`
        : null,
      
      requestorID: null,
     requestor: requestor 
        ? Array.isArray(requestor) 
          ? requestor.filter(Boolean).join(',') // Remove empty values and join with commas
          : [requestor].filter(Boolean).join(',') // Convert single value to array, filter, and join
        : null,
      search:search||null,
      userTimeZone : Intl.DateTimeFormat().resolvedOptions().timeZone

    };
    setFilters(filters); // ✅ update in parent
    //handlePageChange(1);
    handlePageChange(1); 
    fetchData(filters, 1, recordsPerPage, userId,keySort,sortOrder,tab); 
  };
  // useEffect(() => {
  //   handlePageChange(1);
  // }, [tabState]);

  const API_URL = '/RequestForm';
  const handleReset = (tab: string) => {
    const inputElement = document.getElementById("search-input") as HTMLInputElement;
    const search = inputElement?.value.trim().toLowerCase();
    setRequestor("");
    setRequest("");
    setapplication("");
    setSubtypes([]);
    setSubid(null);   // ✅ add this
    setApplicationSubType("");
    setApplicationType("");
    setSelectedDate(null);
    setSelectedToDate(null);
    setStatus("");
    setCompany("");
    if(loggedinuser.roles.toLowerCase().includes("super")){
      setCompanyId(null);
    }else{
    setCompanyId(loggedinuser.companyId);
    }
    const defaultFilters = {
         search: search || null,
    applicationType: "",
    applicationSubType: "",
    setSubtypes: [], // ✅ send empty array
    setSubid:null,
    setApplicationSubType:"",
    status: "",
    company: "",
    requestor: "",
    request: ""
  };
   setFilters(defaultFilters);
   handlePageChange(1);
    fetchData(defaultFilters, 1, recordsPerPage, userId, keySort,sortOrder,tab);
  
  };

useImperativeHandle(ref, () => ({
  resetTab: handleReset
}));

  const linkColumn = "RequestId";
  const [applicationSubType, setApplicationSubType] = useState("");
  const [subtype, setSubtypes] = useState<SubtypeGroup[]>([]);
const [subid, setSubid] = useState<string | null>(null);
  const [companyFilter, setCompanyFilter] = useState<string>('');
  const [loadingExcel, setLoadingExcel] = useState(false);
  const maxCellLength = 32000;
    const [isUser, setisUser] = useState(false);
const extractedImages: string[] = [];
const formatHtmlForExcel = (html: string): string => {
  if (!html) return "";

  const parser = new DOMParser();
  const doc = parser.parseFromString(html, "text/html");
  const walker = doc.createTreeWalker(doc.body, NodeFilter.SHOW_ELEMENT | NodeFilter.SHOW_TEXT);

  let result = "";
  let currentListType: "ul" | "ol" | null = null;
  let listItemIndex = 1;
  let lastNodeType: number | null = null;

  while (walker.nextNode()) {
    const node = walker.currentNode as HTMLElement;

    if (node.nodeType === Node.TEXT_NODE) {
      let text = node.textContent || "";
      text = text.replace(/\s+/g, " "); // normalize spaces

      // Add a space if previous node was also text or inline element
      if (result && !result.endsWith(" ") && lastNodeType === Node.TEXT_NODE) {
        result += " ";
      }

      result += text;
      lastNodeType = Node.TEXT_NODE;
      continue;
    }

    const tag = node.nodeName;

    if (tag === "BR") {
      result += "\n\n";
      lastNodeType = node.nodeType;
    } else if (tag === "P") {
      if (result.trim().length > 0 && !result.endsWith("\n")) result += "\n";
      lastNodeType = node.nodeType;
    } else if (tag === "UL") {
      currentListType = "ul";
      listItemIndex = 1;
      lastNodeType = node.nodeType;
    } else if (tag === "OL") {
      currentListType = "ol";
      listItemIndex = 1;
      lastNodeType = node.nodeType;
    } else if (tag === "LI") {
      const text = node.textContent?.trim() || "";
      if (currentListType === "ol") {
        result += `\n${listItemIndex}. ${text}`;
        listItemIndex++;
      } else {
        result += `\n• ${text}`;
      }
      lastNodeType = node.nodeType;
    } else if (tag === "IMG") {
      const src = node.getAttribute("src");
      const alt = node.getAttribute("alt") || "Image";
      if (src) {
        result += `\n[${alt}]`;
      }
      lastNodeType = node.nodeType;
    } else {
      // Inline elements like <strong>, <em>, <span>
      // Don't duplicate content, just ensure spacing if needed
      if (lastNodeType === Node.TEXT_NODE && !result.endsWith(" ")) {
        result += " ";
      }
      lastNodeType = node.nodeType;
    }
  }

  result = result.replace(/\n{3,}/g, "\n\n").trim();
  return result;
};

// Converts HTML to ExcelJS rich text with bold/strong support
// Converts HTML to ExcelJS rich text without extra line breaks for paragraphs
// Converts HTML to ExcelJS rich text without extra line breaks for paragraphs
const htmlToRichText = (html: string): ExcelJS.CellValue => {
  if (!html) return '';

  const parser = new DOMParser();
  const doc = parser.parseFromString(html, 'text/html');
  const richText: ExcelJS.RichText[] = [];

  const parseNode = (node: Node, inheritedFont: Partial<ExcelJS.Font> = {}) => {
    if (node.nodeType === Node.TEXT_NODE) {
      const text = node.textContent || '';
      
      // Handle &nbsp; and other whitespace
      let processedText = text.replace(/\u00A0/g, ' '); // Convert &nbsp; to space
      
      // Only add text if it's not empty
      if (processedText) {
        richText.push({ 
          text: processedText, 
          font: { ...inheritedFont } 
        });
      }
      return;
    }

    if (node.nodeType === Node.ELEMENT_NODE) {
      const el = node as HTMLElement;
      const style = getComputedStyleFromString(el.getAttribute('style'));
      const currentFont: Partial<ExcelJS.Font> = { ...inheritedFont };

      // ✅ BOLD LOGIC - Handle both inline styles and HTML tags
      if (
        style['font-weight'] === 'bold' || 
        style['font-weight'] === '700' ||
        el.tagName === 'B' || 
        el.tagName === 'STRONG'
      ) {
        currentFont.bold = true;
      }

      // Other font styles
      if (style.color) currentFont.color = { argb: rgbToArgb(style.color) };
      if (
        style['font-style'] === 'italic' ||
        el.tagName === 'I' ||
        el.tagName === 'EM'
      )
        currentFont.italic = true;
      if (style['text-decoration']?.includes('underline'))
        currentFont.underline = true;

      // Handle structural elements
      if (el.tagName === 'BR') {
        richText.push({ text: '\n\n', font: currentFont });
        return;
      }

      // For P and DIV tags - NO AUTOMATIC NEWLINES
      if (el.tagName === 'P' || el.tagName === 'DIV') {
        // Process child nodes without adding any newlines
        el.childNodes.forEach((child) => parseNode(child, currentFont));
        return;
      }

      // For all other inline elements (span, strong, b, etc.)
      el.childNodes.forEach((child) => parseNode(child, currentFont));
    }
  };

  doc.body.childNodes.forEach((node) => parseNode(node));
  
  // Clean up: remove empty text nodes and handle whitespace properly
  const cleanedRichText: ExcelJS.RichText[] = [];
  
  richText.forEach((item) => {
    if (!item.text) return;
    
    let currentText = item.text;
    
    // Normalize whitespace: replace multiple spaces with single space
    currentText = currentText.replace(/[^\S\n]+/g, ' ');
    
    if (currentText) {
      cleanedRichText.push({
        text: currentText,
        font: item.font
      });
    }
  });

  return { richText: cleanedRichText };
};

// Keep your existing helper functions
const getComputedStyleFromString = (styleStr: string | null): Record<string, string> => {
  const styles: Record<string, string> = {};
  if (!styleStr) return styles;
  styleStr.split(';').forEach((s) => {
    const [key, val] = s.split(':').map((x) => x.trim());
    if (key && val) styles[key.toLowerCase()] = val;
  });
  return styles;
};

const rgbToArgb = (rgb: string): string => {
  const match = rgb.match(/\d+/g);
  if (!match) return 'FF000000';
  const [r, g, b] = match.map(Number);
  return `FF${r.toString(16).padStart(2, '0')}${g.toString(16).padStart(2, '0')}${b.toString(16).padStart(2, '0')}`.toUpperCase();
};
 const splitLongText = (text: string, maxLength: number = 32000): string[] => {
  console.log("Raw length:", text?.length);
console.log("JSON length:", JSON.stringify(text)?.length);
  const parts: string[] = [];
  let index = 0;
  let partNumber = 1;
  while (index < text.length) {
    const suffix = ` ...(part ${partNumber})`;
    const chunkSize = maxLength - suffix.length;
    const chunk = text.slice(index, index + chunkSize) + suffix;
    parts.push(chunk);
    index += chunkSize;
    partNumber++;
  }
  return parts;
};
 const handleDownloadExcel = async () => {
  setLoadingExcel(true);
  let resolveCompanyId = null;
  if (!loggedinuser.roles.toLowerCase().includes("super")) {
    resolveCompanyId = loggedinuser.companyId;
    setisUser(true);
  }
   let resolveCompanyCode = companyId ;             // For Super Admin filter Excel Download (CompanyCode).

  const API_URL = '/RequestForm';
  const tab = getHeading();
  let response = null;

  try {
    // Step 1: Fetch data
    const tabRoutes = {
      "My Requests": `GetDashboadData?userId=${userId}`,
      "My Reviews": `GetDashboadDataReview?userId=${userId}`,
      "My Actioned Requests": `GetDashboadDataActioned?userId=${userId}&isActionComplete=true`,
      "All Requests": `GetAllRequestExcelData?companyId=${resolveCompanyCode}&userTimeZone=${filters.userTimeZone}`,
      "My Pending Approvals": `GetDashboadDataPending?userId=${userId}`,
      "My Pending Resubmissions": `GetDashboadData?userId=${userId}&formAction=${encodeURIComponent("request for amendment")}`,
      "My Drafts": `GetDashboadData?userId=${userId}&formAction=draft`,
    };

    const route = tabRoutes[tab];
    if (!route) {
      toast.error("Invalid tab selected.");
      return;
    }

    // Build query string manually (excluding filters)
    const url = `${API_URL}/${route}&pagination=false&sortColumn=${sortColumn}&sortOrder=${sortOrder}`;
    
    // Determine if filters are applied
    const isFilterApplied =
      filters &&
      Object.values(filters).some(
        (v) => v !== null && v !== "" && (Array.isArray(v) ? v.length > 0 : true)
      );
      
    // Attach filters as `params` only if applied
    response = await nexapi.get(url, {
      params: isFilterApplied ? filters : {},
    });

    const data = response?.data?.data || [];

    if (!Array.isArray(data) || data.length === 0) {
      toast.error("No data available to download!");
      return;
    }
    
    // Step 2: Data Transformation
    const APPROVER_KEYS = Array.from({ length: 9 }, (_, i) => `Approver${i + 1}`);
    const REFERENCE_KEYS = Array.from({ length: 12 }, (_, i) => `Refrence${i + 1}`);

    const formatDate = (d) =>
      d
        ? new Date(d).toLocaleString("en-GB", {
            day: "2-digit",
            month: "short",
            year: "numeric",
            hour: "2-digit",
            minute: "2-digit",
            hour12: true,
          }).replace("Sept", "Sep")
        : "";
const formatDateForFROMTO = (dateStr: string): string => {
    if (!dateStr) return "";
    const [year, month, day] = dateStr.split("-").map(Number);
const date = new Date(year, month - 1, day);
    const options: Intl.DateTimeFormatOptions = {
      day: "2-digit",
      month: "short",
      year: "numeric",
    };
      let formatted = date.toLocaleString("en-GB", options);
  // Only replace if month is September
  if (date.getMonth() === 8) { // 0 = Jan, 8 = Sep
    formatted = formatted.replace("Sept", "Sep");
  }
  return formatted;
    //return date.toLocaleDateString("en-GB", options); // Outputs: 31 Mar 2025
  };
    const filteredData = data.flatMap((item) => {
      const approverFields = Object.fromEntries(APPROVER_KEYS.map(k => [k, ""]));
      if (Array.isArray(item.approver)) {
        item.approver.forEach(({ sequence, approverModel }) => {
          if (sequence >= 1 && sequence <= 9) {
            approverFields[`Approver${sequence}`] = approverModel?.givenName || "";
          }
        });
      }
      
     const refrenceFields = {};

if (Array.isArray(item.refrence) && item.refrence.length > 0) {

  // Step 1: Check if ANY field has value
  const hasAnyValue = item.refrence.some(({ subtypeField }) => {
    if (!subtypeField) return false;

    const value = subtypeField.value || "";

    if (subtypeField.fieldType === "TextBox") {
      return value.trim() !== "";
    }

    if (subtypeField.fieldType === "CheckBox") {
      return value === "true";
    }

    return false;
  });

  // Step 2: If at least one value exists → append ALL labels
  if (hasAnyValue) {
    item.refrence.forEach(({ subtypeField }) => {
      if (!subtypeField) return;

      const fieldName = subtypeField.fieldName || "Unknown";
      const sequence = subtypeField.sequenceNumber || 0;
      const key = `Refrence${sequence}`;
      const value = subtypeField.value || "";

      let displayValue = "";

      if (subtypeField.fieldType === "TextBox") {
        displayValue = value.trim();
      } 
      else if (subtypeField.fieldType === "CheckBox") {
        displayValue = value === "true" ? "True" : "False";
      }

      refrenceFields[key] = `[${fieldName}]\n${displayValue}`;
    });
  }

  // Step 3: If no value exists → do nothing (fully blank)
}

// const historyLogs = item.historyLogs || [];

// // Sort oldest → newest
// const sortedLogs = [...historyLogs].sort(
//   (a, b) => new Date(a.createdOn).getTime() - new Date(b.createdOn).getTime()
// );

// // Split requester and approvers based on name match
// const requesterLogs = sortedLogs.filter(
//   (log) => log.userName?.trim().toLowerCase() === item.requestorName?.trim().toLowerCase()
// );
// const approverLogs = sortedLogs.filter(
//   (log) => log.userName?.trim().toLowerCase() !== item.requestorName?.trim().toLowerCase()
// );

// // Requester remarks → take first (or join if multiple)
// const reqRemarks =
//   requesterLogs.length > 0
//     ? requesterLogs
//         .map(
//           (log) =>
//             `${log.userName} (${formatDate(log.createdOn)}) - ${
//               log.remarks ? log.remarks : ""
//             }`
//         )
//         .join("\n")
//     : "";

// // Approver remarks → all other logs
// const approverRemarks =
//   approverLogs.length > 0
//     ? approverLogs
//         .map(
//           (log) =>
//             `${log.userName} (${formatDate(log.createdOn)}) - ${
//               log.remarks ? log.remarks : ""
//             }`
//         )
//         .join("\n")
//     : "";

const historyLogs = item.historyLogs || [];

// Sort oldest → newest
const sortedLogs = [...historyLogs].sort(
  (a, b) => new Date(a.createdOn).getTime() - new Date(b.createdOn).getTime()
);

// ✅ Combine all logs together (Requester + Approvers)
const allRemarksLogs = sortedLogs.filter((log) => log.remarks?.trim());

// ✅ Format combined remarks
const approverRemarks =
  allRemarksLogs.length > 0
    ? allRemarksLogs
        .map(
          (log) =>
            `${log.userName} (${formatDate(log.createdOn)}) - ${
              log.remarks ? log.remarks : ""
            }`
        )
        .join("\n")
    : "";


      const maxDescriptionLength = 32000;
      const formattedDescription = formatHtmlForExcel(item.description || "");
      const descriptionParts = formattedDescription.length > maxDescriptionLength
          ? splitLongText(formattedDescription, maxDescriptionLength)
          : [formattedDescription];

      return descriptionParts.map((descPart, idx) => {
        const base: { [key: string]: any } = {
  Id: item.id,
  RequestId: item.requestID,
  Application: item.applicationTitle,
  Subtype: item.subtypeTitle,
  Requester: item.requestorName,
  Status: item.formActionString.charAt(0).toUpperCase() +
    item.formActionString.slice(1) +
    (item.formActionString.toLowerCase() === "pending" && item?.currentOwnerName?.trim()
      ? " with " + item.currentOwnerName
      : ""),
   SubmittedDate: item.submittedDateTime
      ? formatLocalDateTime(item.submittedDateTime)
      : "-",
    FromDate: formatDateForFROMTO(item.fromDate),
    ToDate: formatDateForFROMTO(item.toDate),
  Subject: item.subject,
  Reviewer: item.reviewer,
  Division:item.division,
  Branch:item.branch,
  Description: descPart,
  Reason: item.reason,
  // RequesterRemark: reqRemarks,
  ApproverRemark: approverRemarks,
  ...approverFields,
  ...refrenceFields,
};

        if (!isUser) {
          base.CompanyCode = item.companyName;
        }

        return base;
      });
    });

    // Step 3: Define headers for each tab
    const exportConfigByTab = {
  "My Requests": {
    keys: [
      "RequestId", "Application", "Subtype", "Requester", "Status", ...(loggedinuser.roles.toLowerCase().includes("super") ? ["CompanyCode"] : []),
      "Division","Branch","SubmittedDate", "FromDate", "ToDate", "Subject", "Reviewer", 
      ...APPROVER_KEYS, "Description", ...REFERENCE_KEYS, 
      "Reason",   "ApproverRemark"
    ],
    headers: [
      "Request ID", "Application", "Sub Type", "Requester", "Status", ...(loggedinuser.roles.toLowerCase().includes("super") ? ["Company Code"] : []), 
      "Division","Branch","Submitted Date", "From Date", "To Date", "Subject", "Reviewers",
      "Approver 1", "Approver 2", "Approver 3", "Approver 4", "Approver 5",
      "Approver 6", "Approver 7", "Approver 8", "Approver 9", "Description",
      "Reference 1", "Reference 2", "Reference 3", "Reference 4", "Reference 5",
      "Reference 6", "Reference 7", "Reference 8", "Reference 9", "Reference 10",
      "Reference 11", "Reference 12", "Reason",   "Remarks"
    ],
    columnWidths: [
      15, 20, 15, 20, 20, ...(loggedinuser.roles.toLowerCase().includes("super") ? [15] : []),
      15,15,20, 15, 15, 30, 20,
      15, 15, 15, 15, 15,
      15, 15, 15, 15, 50,
      15, 15, 15, 15, 15,
      15, 15, 15, 15, 15,
      15, 15, 30, 30, 50
    ]
  },
  "My Reviews": {
     keys: [
      "RequestId", "Application", "Subtype", "Requester", "Status", ...(loggedinuser.roles.toLowerCase().includes("super") ? ["CompanyCode"] : []),
      "Division","Branch","SubmittedDate", "FromDate", "ToDate", "Subject", "Reviewer",
      ...APPROVER_KEYS, "Description", ...REFERENCE_KEYS, 
      "Reason",   "ApproverRemark"
    ],
    headers: [
      "Request ID", "Application", "Sub Type", "Requester", "Status", ...(loggedinuser.roles.toLowerCase().includes("super") ? ["Company Code"] : []),
      "Division","Branch","Submitted Date", "From Date", "To Date", "Subject", "Reviewers",
      "Approver 1", "Approver 2", "Approver 3", "Approver 4", "Approver 5",
      "Approver 6", "Approver 7", "Approver 8", "Approver 9", "Description",
      "Reference 1", "Reference 2", "Reference 3", "Reference 4", "Reference 5",
      "Reference 6", "Reference 7", "Reference 8", "Reference 9", "Reference 10",
      "Reference 11", "Reference 12", "Reason",   "Remarks"
    ],
    columnWidths: [
      15, 20, 15, 20, 20, ...(loggedinuser.roles.toLowerCase().includes("super") ? [15] : []),
       15,15,20, 15, 15, 30, 20,
      15, 15, 15, 15, 15,
      15, 15, 15, 15, 50,
      15, 15, 15, 15, 15,
      15, 15, 15, 15, 15,
      15, 15, 30, 30, 50
    ]
  },
  "My Actioned Requests": {
    keys: [
      "RequestId", "Application", "Subtype", "Requester", "Status", ...(loggedinuser.roles.toLowerCase().includes("super") ? ["CompanyCode"] : []), 
      "Division","Branch","SubmittedDate", "FromDate", "ToDate", "Subject", "Reviewer", 
      ...APPROVER_KEYS, "Description", ...REFERENCE_KEYS, 
      "Reason",   "ApproverRemark"
    ],
    headers: [
      "Request ID", "Application", "Sub Type", "Requester", "Status", ...(loggedinuser.roles.toLowerCase().includes("super") ? ["Company Code"] : []), 
      "Division","Branch","Submitted Date", "From Date", "To Date", "Subject", "Reviewers",
      "Approver 1", "Approver 2", "Approver 3", "Approver 4", "Approver 5",
      "Approver 6", "Approver 7", "Approver 8", "Approver 9", "Description",
      "Reference 1", "Reference 2", "Reference 3", "Reference 4", "Reference 5",
      "Reference 6", "Reference 7", "Reference 8", "Reference 9", "Reference 10",
      "Reference 11", "Reference 12", "Reason",   "Remarks"
    ],
    columnWidths: [
      15, 20, 15, 20, 15, ...(loggedinuser.roles.toLowerCase().includes("super") ? [15] : []),
       15,15,20, 15, 15, 30, 20,
      15, 15, 15, 15, 15,
      15, 15, 15, 15, 50,
      15, 15, 15, 15, 15,
      15, 15, 15, 15, 15,
      15, 15, 30, 30, 50
    ]
  },
  "All Requests": {
    keys: [
      "RequestId", "Application", "Subtype", "Requester", "Status", ...(loggedinuser.roles.toLowerCase().includes("super") ? ["CompanyCode"] : []),
      "SubmittedDate", "Subject"
    ],
    headers: [
      "Request ID", "Application", "Sub Type", "Requester", "Status", 
      ...(loggedinuser.roles.toLowerCase().includes("super") ? ["Company Code"] : []), "Submitted Date", "Subject"
    ],
    columnWidths: [
      15, 20, 15, 20, 20, ...(loggedinuser.roles.toLowerCase().includes("super") ? [15] : []), 20, 50
    ]
  },
  "My Pending Approvals": {
    keys: [
      "RequestId", "Application", "Subtype", "Requester", "Status", ...(loggedinuser.roles.toLowerCase().includes("super") ? ["CompanyCode"] : []),
      "Division","Branch","SubmittedDate", "FromDate", "ToDate", "Subject", "Reviewer",
      ...APPROVER_KEYS, "Description", ...REFERENCE_KEYS, 
      "Reason",   "ApproverRemark"
    ],
    headers: [
      "Request ID", "Application", "Sub Type", "Requester", "Status", ...(loggedinuser.roles.toLowerCase().includes("super") ? ["Company Code"] : []),
     "Division","Branch", "Submitted Date", "From Date", "To Date", "Subject", "Reviewers",
      "Approver 1", "Approver 2", "Approver 3", "Approver 4", "Approver 5",
      "Approver 6", "Approver 7", "Approver 8", "Approver 9", "Description",
      "Reference 1", "Reference 2", "Reference 3", "Reference 4", "Reference 5",
      "Reference 6", "Reference 7", "Reference 8", "Reference 9", "Reference 10",
      "Reference 11", "Reference 12", "Reason",   "Remarks"
    ],
    columnWidths: [
      15, 20, 15, 20, 20, ...(loggedinuser.roles.toLowerCase().includes("super") ? [15] : []),
       15,15,20, 15, 15, 30, 20,
      15, 15, 15, 15, 15,
      15, 15, 15, 15, 50,
      15, 15, 15, 15, 15,
      15, 15, 15, 15, 15,
      15, 15, 30, 30, 50
    ]
  },
  "My Pending Resubmissions": {
    keys: [
      "RequestId", "Application", "Subtype", "Requester", "Status", ...(loggedinuser.roles.toLowerCase().includes("super") ? ["CompanyCode"] : []),
      "Division","Branch","SubmittedDate", "FromDate", "ToDate", "Subject", "Reviewer", 
      ...APPROVER_KEYS, "Description", ...REFERENCE_KEYS, 
      "Reason",   "ApproverRemark"
    ],
    headers: [
      "Request ID", "Application", "Sub Type", "Requester", "Status", ...(loggedinuser.roles.toLowerCase().includes("super") ? ["Company Code"] : []),
      "Division","Branch","Submitted Date", "From Date", "To Date", "Subject", "Reviewers",
      "Approver 1", "Approver 2", "Approver 3", "Approver 4", "Approver 5",
      "Approver 6", "Approver 7", "Approver 8", "Approver 9", "Description",
      "Reference 1", "Reference 2", "Reference 3", "Reference 4", "Reference 5",
      "Reference 6", "Reference 7", "Reference 8", "Reference 9", "Reference 10",
      "Reference 11", "Reference 12", "Reason",   "Remarks"
    ],
    columnWidths: [
      15, 20, 15, 20, 20, ...(loggedinuser.roles.toLowerCase().includes("super") ? [15] : []),
       15,15,20, 15, 15, 30, 20,
      15, 15, 15, 15, 15,
      15, 15, 15, 15, 50,
      15, 15, 15, 15, 15,
      15, 15, 15, 15, 15,
      15, 15, 30, 30, 50
    ]
  },
  "My Drafts": {
    keys: [
      "RequestId", "Application", "Subtype", "Subject"
    ],
    headers: [
      "Request ID", "Application", "Sub Type", "Subject"
    ],
    columnWidths: [
      15, 20, 15, 50
    ]
  }
};

const originalConfig = exportConfigByTab[tab] || {
      keys: [],
      headers: [],
      columnWidths: []
    };

    // Clone the config to modify
    const config = {
      keys: [...originalConfig.keys],
      headers: [...originalConfig.headers],
      columnWidths: [...originalConfig.columnWidths]
    };

    if (isUser) {
      const companyIdx = config.keys.indexOf("CompanyCode");
      if (companyIdx !== -1) {
        config.keys.splice(companyIdx, 1);
        config.headers.splice(companyIdx, 1);
        config.columnWidths.splice(companyIdx, 1);
      }
    }
    // Step 4: Create Excel with ExcelJS
    const workbook = new ExcelJS.Workbook();
    const worksheet = workbook.addWorksheet(tab);

// 1. Calculate the last column letter dynamically
  const lastColIndex = config.headers.length;
  const lastColLetter = getExcelColumnLetter(lastColIndex);
  
  // 2. Title row - properly merged and centered
  worksheet.mergeCells(`A1:${lastColLetter}1`);
  const titleRow = worksheet.getRow(1);
  titleRow.getCell(1).value = tab;
  titleRow.getCell(1).font = { 
    bold: false,
    size: 11
  };
  titleRow.getCell(1).alignment = { 
    horizontal: 'center',
    vertical: 'middle'
  };
  titleRow.height = 20;

    // Add headers row
    const headerRow = worksheet.addRow(config.headers);
    headerRow.font = { bold: true };
    headerRow.alignment = { wrapText: true, vertical: 'middle' };
    // headerRow.eachCell((cell) => {
    //   cell.border = {
    //     top: { style: 'thin' },
    //     left: { style: 'thin' },
    //     bottom: { style: 'thin' },
    //     right: { style: 'thin' }
    //   };
    // });

    // Set column widths
    config.columnWidths.forEach((width, index) => {
      worksheet.getColumn(index + 1).width = width;
    });

    // Add data rows
filteredData.forEach(item => {
  const row = worksheet.addRow([]);
  config.keys.forEach((key, index) => {
    const cell = row.getCell(index + 1);

if (key === "Description") {
  const descHtml = item[key] ?? "";
  const richValue = htmlToRichText(descHtml);
  cell.value = richValue;
  cell.alignment = { vertical: 'middle', wrapText: true };
}

else if (key === "SubmittedDate" && item[key] && item[key] !== "-") {

  const parts = item[key].replace(",", "").split(" ");

  const day = parseInt(parts[0]);
  const month = new Date(Date.parse(parts[1] + " 1, 2000")).getMonth();
  const year = parseInt(parts[2]);

  let [hour, minute] = parts[3].split(":").map(Number);

  if (parts[4].toLowerCase() === "pm" && hour !== 12) hour += 12;
  if (parts[4].toLowerCase() === "am" && hour === 12) hour = 0;

  // 🔥 IMPORTANT → create UTC date
  const excelDate = new Date(Date.UTC(year, month, day, hour, minute));

  cell.value = excelDate;
  cell.numFmt = "d mmm yyyy, hh:mm AM/PM";
  cell.alignment = { vertical: "middle", wrapText: true };
}

else if ((key === "FromDate" || key === "ToDate") && item[key]) {

  const parts = item[key].split(" ");

  const day = parseInt(parts[0]);
  const month = new Date(Date.parse(parts[1] + " 1, 2000")).getMonth();
  const year = parseInt(parts[2]);

  const excelDate = new Date(Date.UTC(year, month, day));

  cell.value = excelDate;
  cell.numFmt = "d mmm yyyy";
  cell.alignment = { vertical: "middle", wrapText: true };
}
else {
  cell.value = item[key] ?? "";
  cell.alignment = { vertical: 'middle', wrapText: true };
}
  });
});
//    New techni
    // // Style all cells
    // worksheet.eachRow({ includeEmpty: false }, (row) => {
    //   row.eachCell({ includeEmpty: false }, (cell) => {
    //     cell.border = {
    //       top: { style: 'thin' },
    //       left: { style: 'thin' },
    //       bottom: { style: 'thin' },
    //       right: { style: 'thin' }
    //     };
    //   });
    // });

    // Generate Excel file
    const buffer = await workbook.xlsx.writeBuffer();
    saveAs(new Blob([buffer]), `${tab.replace(/[/\\?*[\]]/g, '-')}.xlsx`);

  } catch (error) {
    console.error("Excel download failed:", error);
    toast.error("Download failed. Please try again.");
  } finally {
    setLoadingExcel(false);
  }
};

const getExcelColumnLetter = (columnNumber) => {
  let letter = '';
  while (columnNumber > 0) {
    let remainder = (columnNumber - 1) % 26;
    letter = String.fromCharCode(65 + remainder) + letter;
    columnNumber = Math.floor((columnNumber - 1) / 26);
  }
  return letter;
};


  const maxChars = getDashboardMaxCharsDash();
 const CustomDateInput = React.forwardRef<HTMLInputElement, CustomDateInputProps>(
  ({ value, onClick, onChange, onKeyDown, placeholder }, ref) => (
    <div className="custom-date-input" onClick={onClick}>
      <input
        type="text"
        className="form-control"
        value={value}
        onChange={onChange}
        onKeyDown={onKeyDown}
        ref={ref}
        placeholder={placeholder}
        style={{lineHeight:'1.4'}}
      />
      <img src={dateIcon} className="calendar-icon" />
    </div>
  )
);



  

  return (
    <div className="table-responsive">
      <div className="search-user">
        <div className="row search-heading" style={{ paddingBottom: '15px' }}>
          <div className="col-lg-5">
            <h3>{getHeading()}</h3>
          </div>
          {tabState !== 'drafts' && (
            <div className="col-lg-7">
              <div className="input-group" style={{ gap: "3%" }}>
                <div 
                  className="search-box searchBorder" 
                  style={{ 
                    position: "relative", 
                    display: "inline-block",
                    border: "1px solid black",  // Added black border
                    borderRadius: "0.375rem"    // Match the input's rounded corners
                  }}
                >
                    <FaSearch style={{ 
                    position: "absolute", 
                    right: "10px", 
                    top: "20px", 
                    width: "24px",  // Increased from 19px
                    height: "19px",
                    transform: "translateY(-50%)", 
                    color: "#A2A2B0"   
                  }} />
                  <input
                    type="text"
                    className="form-control rounded"
                    style={{
                      border: "none",           // Remove default input border
                      boxShadow: "none",         // Remove any focus shadows
                      paddingRight: "40px", // Add padding to prevent text overlap
                      width: "100%" // Ensure input takes full width of container
                    }}
                    placeholder="Search Records"
                    aria-label="Search"
                    aria-describedby="search-addon"
                    id="search-input"
                  />
                </div>
                <button
                  type="button"
                  className="btn btn-primary search-button"
                  style={{    borderRadius: "4px"}}
                  id="pending-approval-search-btn"
                  onClick={() => handleSearchClick(tabState)}
                >
                  Search
                </button>
                <div id="main"></div>
              </div>
            </div>
          )}
          <div className="container">
            <div className="accordion md-accordion" id="faq" style={{ textAlign: 'center' }}>
            {tabState !== 'drafts' && (
              <div className='advanceBox container advInsider'>
                  <div id="faqhead1" className='mt-3'>
                    <a
                      href="#"
                      id="adv-srh"
                      className="adv-search adv-search-css"
                      onClick={toggleCollapse}
                      aria-expanded={!isCollapsed}
                      aria-controls="faq1"
                    >
                      Advance Search
                      <i
                        id="arrow-pendingapproval"
                        className={`fa ${isCollapsed ? 'fa-chevron-up' : 'fa-chevron-down'}`}
                        aria-hidden="true"
                      ></i>
                    </a>
                  </div>
                
                <div
                  id="faq1"
                  className={`panel-collapse ${isCollapsed ? 'collapse' : 'collapse show'}`}
                  aria-labelledby="faqhead1"
                  data-parent="#faq"
                >
                  <div className="mt-4" style={{ textAlign: 'left' }}>
                    <form >
                      <div className="row">
                        <div className="col-12 col-lg-3">
                          <div className="form-group">
                            <label htmlFor="exampleFormControlInput1" className="fontTitle">
                              Request ID
                            </label>
                            <input type="text" className="form-control" id="requestID" placeholder="Request ID" autoComplete="off" value={request} style={{lineHeight:'1.4'}} onChange={handleRequestChange} />
                          </div>
                        </div>
                       <div className="col-12 col-lg-3 mb-3">
  <label className="fontTitle">
    Application Type
  </label>
  <select
    className={`form-control form-select ${errors.applicationType ? 'invalidForm' : ''}`}
    onChange={(e) => {
      const selectedValue = e.target.value;
      const selectedText = e.target.options[e.target.selectedIndex].text;
      setApplicationType(selectedValue);
      setSelectedAppLabel(selectedText);
      handleInputChange(e, setApplicationType);
      if (selectedValue.trim()) {
        setErrors((prev) => ({ ...prev, applicationType: '' }));
      }
    }}
    value={application}
  >
    <option value="">&nbsp;&nbsp;Application Type</option>
    {applications.map((app) => (
      <option key={app.id} value={app.id}>
        &nbsp;&nbsp;{app.name.length > 20 ? `${app.name.substring(0, 20)}...` : app.name}
      </option>
    ))}
  </select>
  {errors.applicationType && (
    <div className="text-danger mt-1">{errors.applicationType}</div>
  )}
</div>

{/* Sub Type Dropdown */}
<div className="col-12 col-lg-3 mb-3">
  <label className="fontTitle">
    Sub Type
  </label>
  <select style={{padding:'.375rem 1.25rem 0.375rem 0.75rem'}}
    id="subtypeID"
    className={`form-control form-select ${errors.applicationSubType ? 'invalidForm' : ''}`}
    data-bs-toggle="tooltip"
    
title={selectedTooltip}
     onChange={(e) => {
       handleSubtype(e, setApplicationSubType);
      if (e.target.value.trim()) {
        setErrors((prev) => ({ ...prev, applicationSubType: '' }));
      }
  const selectedId = e.target.value;

  const allSubtypes: any[] = [];
  subtype.forEach(group => {
    if (group.subtypes) {
      group.subtypes.forEach(sub => {
        allSubtypes.push(sub);
      });
    }
  });

  const selectedSub = allSubtypes.find(s => s.subtypeId === selectedId);

  setSelectedTooltip(selectedSub?.fieldName || "");
  }}
  >
    <option value="">&nbsp;&nbsp;Sub Type</option>
    {subtype?.map((group) =>
      group?.subtypes?.length > 0 ? (
        <optgroup
          key={group.name}
          label={`\u00a0\u00a0${group.name}`}
          style={{ fontWeight: 'bolder', color: '#323232' }}
        >
          {sortByKeyAsc(group.subtypes, 'fieldName').map((sub) => (
            <option
              key={sub.subtypeId}
              value={sub.subtypeId}
              title={sub.tooltip}
              data-tooltip={sub.inDepthTooltipID}
              style={{
                fontSize: '1rem',
                fontWeight: '400',
                lineHeight: '1.5',
                color: '#495057',
              }}
            >
                &nbsp;&nbsp;{sub.fieldName.length > 22 ? `${sub.fieldName.substring(0, 22)}...` : sub.fieldName}
            </option>
          ))}
        </optgroup>
      ) : null
    )}
  </select>
  {errors.applicationSubType && (
    <div className="text-danger mt-1">{errors.applicationSubType}</div>
  )}
</div>


                        
                        {tabState !== 'myrequest' && tabState !== 'resubmission' && tabState !== 'actioned' && tabState !== 'pending-approvals' &&  tabState !== 'reviews' &&  tabState !== 'allrequests'  && (
                        <div className="col-12 col-lg-3">
                          <div className="form-group">
                            <label htmlFor="exampleFormControlInput1" className="fontTitle">
                              Requester
                            </label>
                            {/* <select id="requestorId" className="form-control" onChange={(e) => handleRequestor(e, setRequestor)} value={requestor}>
                              <option value="0"></option>
                              {dataUser?.map((app) => (
                                <option key={app.id} value={app.id}>
                                  &nbsp;&nbsp;{app.name}
                                </option>
                              ))}
                            </select> */}
                                <Select
                                  options={filteredOptions.length > 0 ? filteredOptions : []}
                                  value={
  options && Array.isArray(options)
    ? options.find((opt) => opt.value === requestor) || null
    : null
}

                                menuPortalTarget={document.body}
                                  menuPosition="fixed"
                                  styles={{
                                    menu: (base) => ({
                                      ...base,
                                      minWidth: "270px",
                                      zIndex: 9999,
                                    }),
                                    option: (base, state) => ({
                                      ...base,
                                      backgroundColor: state.isFocused ? "#ffc0cb" : "white",
                                      color: "#000",
                                      display: "flex",
                                      alignItems: "center",
                                      gap: "8px",
                                    }),
                                  }}
                                  onChange={(selectedOption) => {
                                    const inputContainer = document.querySelector(".select__input-container") as HTMLElement | null;

                                    if (selectedOption) {
                                      setRequestor(selectedOption.value);

                                      setRecentUsers((prev) => {
                                        const exists = prev.find((u) => u.value === selectedOption.value);
                                        const updated = exists ? prev : [selectedOption, ...prev];
                                        return updated.slice(0, 5);
                                      });

                                      setShowSuggestions(false);
                                      if (inputContainer) {
                                        inputContainer.style.height = "0px";
                                        inputContainer.style.paddingTop = "0px";
                                      }
                                    } else {
                                      setRequestor("");
                                      setShowSuggestions(false);
                                      if (inputContainer) {
                                        inputContainer.style.height = "";
                                        inputContainer.style.paddingTop = "";
                                      }
                                    }
                                  }}
                                  onInputChange={(newInputValue) => {
                                   
                                    setInputRequesterValue(newInputValue);
                                    if (newInputValue.length >= 3) {
                                       
                                      const filtered = options.filter(
                                        (opt) =>
                                          opt.label.toLowerCase().includes(newInputValue.toLowerCase()) ||
                                          opt.email.toLowerCase().includes(newInputValue.toLowerCase())
                                      );
                                      setFilteredOptions(filtered);
                                    } else if (newInputValue === "") {
                                      setFilteredOptions(recentUsers);
                                    } else {
                                      setFilteredOptions([]);
                                    }
                                  }}
                                  onFocus={() => setShowSuggestions(true)}
                                  placeholder=" "
                                  className={`basic-single-select ${showSuggestions ? "active-underline" : ""}`}
                                  classNamePrefix="select"
                                  isClearable={false}
                                  menuIsOpen={showSuggestions}
                                  getOptionValue={(option) => option.value}
                                   filterOption={(option, rawInput) => {
                                    const input = rawInput.toLowerCase();
                                    const name = option.data?.label?.toLowerCase() || '';
                                    const email = option.data?.email?.toLowerCase() || '';
                                    return name.includes(input) || email.includes(input);
                                  }}
                                  formatOptionLabel={(option, { inputValue }) => {
                                    const lowerLabel = option.label.toLowerCase();
                                    const lowerInput = inputValue.toLowerCase();
                                    const startIndex = lowerLabel.indexOf(lowerInput);
                                    const endIndex = startIndex + inputValue.length;

                                    return (
                                      <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
                                        <img
                                          src={option.image || defaultImage}
                                          alt="user"
                                          style={{ width: 20, height: 20, borderRadius: "50%" }}
                                        />
                                        <div>
                                          {startIndex >= 0 && inputValue ? (
                                            <>
                                              {option.label.length > 20 ? `${option.label.substring(0, 20)}...` : option.label}
                                            </>
                                          ) : (
                                            option.label
                                          )}
                                          <div style={{ fontSize: "12px", color: "#000" }}>
                                            {option.email.length > 27 ? `${option.email.substring(0, 27)}...` : option.email}
                                          </div>
                                        </div>
                                      </div>
                                    );
                                  }}
                                  components={{
                                    MenuList,
                                    NoOptionsMessage,
                                    SingleValue: (props) => (
                                      <CustomSingleValue
                                        {...props}
                                        setShowSuggestions={setShowSuggestions}
                                        setInputRequesterValue={setInputRequesterValue}
                                        handleSearchRequestor={handleSearchRequestor}
                                      />
                                    ),
                                  }}
                                />


                          </div>
                        </div>
                        )}
                      {(tabState === 'actioned' || tabState === 'pending-approvals' ||  tabState ==='reviews' || tabState==='allrequests')  && (
                          <div className="col-12 col-lg-3">
                            <div className="form-group">
                              <label htmlFor="exampleFormControlInput1" className="fontTitle">
                                Requester
                              </label>
                              <Select
                                isMulti
                              value={requestor 
                                  ? requestor.split(',').slice(0, 5).map(val => options.find(opt => opt.value === val)).filter(Boolean) 
                                  : []}
                                onChange={(selectedOptions) => {
                                  // Limit to 5 selections
                                  const limitedOptions = selectedOptions ? selectedOptions.slice(0, 5) : [];
                                  const selectedValues = limitedOptions.map(opt => opt.value).join(',');
                                  setRequestor(selectedValues);
                                  
                                  if (limitedOptions.length) {
                                    setRecentUsers(prev => {
                                      const newOptions = limitedOptions.filter(opt => 
                                        !prev.some(u => u.value === opt.value)
                                      );
                                      return [...newOptions, ...prev].slice(0, 5);
                                    });
                                  }
                                }}
                                onInputChange={(newInputValue) => {
                                  setInputRequesterValue(newInputValue);
                                  if (newInputValue.length >= 3) {
                                    const filtered = options.filter(
                                      opt =>
                                        opt.label.toLowerCase().includes(newInputValue.toLowerCase()) ||
                                        opt.email.toLowerCase().includes(newInputValue.toLowerCase())
                                    );
                                    setFilteredOptions(filtered);
                                  } else if (newInputValue === "") {
                                    setFilteredOptions(recentUsers);
                                  } else {
                                    setFilteredOptions([]);
                                  }
                                }}
                                placeholder=""
                                className="basic-multi-select"
                                classNamePrefix="select"
                                inputValue={inputRequesterValue}
                                onMenuOpen={() => setShowSuggestions(true)}
                                onMenuClose={() => setShowSuggestions(false)}
                                menuIsOpen={showSuggestions || inputRequesterValue.length > 0}
                                options={filteredOptions.length > 0 ? filteredOptions : []}
                                getOptionValue={(option) => option.value}
                                getOptionLabel={(option) => `${option.label} (${option.email})`}
                                filterOption={(option, rawInput) => {
                                    const input = rawInput.toLowerCase();
                                    const name = option.data?.label?.toLowerCase() || '';
                                    const email = option.data?.email?.toLowerCase() || '';
                                    return name.includes(input) || email.includes(input);
                                  }}
                                formatOptionLabel={(option) => (
                                  <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
                                    <img
                                      src={option.image || defaultImage}
                                      alt="user"
                                      style={{ width: 30, height: 30, borderRadius: "50%", objectFit: "cover" }}
                                    />
                                    <div>
                                      <div style={{
                                        whiteSpace: "nowrap",
                                        color: "rgb(0, 0, 0)",
                                        fontWeight: 400,
                                        fontSize: "14px"
                                      }}>
                                        {option.label.length > 20 ? `${option.label.substring(0, 20)}...` : option.label}
                                      </div>
                                      <div style={{
                                        whiteSpace: "nowrap",
                                        color: "#000",
                                        fontWeight: 400,
                                        fontSize: "12px"
                                      }}>
                                        {option.email.length > 27 ? `${option.email.substring(0, 27)}...` : option.email}
                                      </div>
                                    </div>
                                  </div>
                                )}
                                noOptionsMessage={() => "No results found"}
                                styles={{
                                  control: (base, state) => ({
                                    ...base,
                                    minHeight: '33px',
                                    height: 'auto',
                                    maxHeight: '120px',
                                    overflowY: 'auto',
                                    width: '100%',
                                    padding: '4px 8px',
                                    flexWrap: 'wrap',
                                    alignItems: 'flex-start',
                                    borderColor: state.isFocused 
                                      ? '#86b7fe' 
                                      : base.borderColor,
                                    boxShadow: state.isFocused 
                                      ? '0 0 0 .25rem rgba(13, 110, 253, .25)' 
                                      : base.boxShadow,
                                    '&:hover': {
                                      borderColor: state.isFocused 
                                        ? '#86b7fe' 
                                        : '#ff585d'
                                    },
                                    // Match Bootstrap's form-control focus styles
                                    '&:focus-within': {
                                      color: 'var(--bs-body-color)',
                                      backgroundColor: 'var(--bs-body-bg)',
                                      borderColor: '#86b7fe',
                                      outline: 0,
                                      boxShadow: '0 0 0 .25rem rgba(13, 110, 253, .25)'
                                    }
                                  }),
                                  valueContainer: (base) => ({
                                    ...base,
                                    padding: 0,
                                    gap: '4px',
                                    flexWrap: 'wrap', // Allow items to wrap
                                    alignItems: 'flex-start', // Align items to the top
                                  }),
                                  input: (base) => ({
                                    ...base,
                                    margin: 0,
                                    padding: 0,
                                    width: '100%', // Make input take full width
                                    position: 'relative', // Ensure proper positioning
                                    top: 0, // Align to top
                                  }),
                                  multiValue: (base) => ({
                                    ...base,
                                    backgroundColor: 'transparent',
                                    padding: 0,
                                    margin: 0,
                                    marginRight: '4px',
                                    marginBottom: '4px',
                                  }),
                                  option: (base, state) => ({
                                    ...base,
                                    backgroundColor: state.isFocused ? "#ffc0cb" : "white",
                                    color: "#000",
                                    padding: '8px 12px'
                                  }),
                                }}
                                components={{
                                  MenuList,
                                  NoOptionsMessage,
                                  MultiValue: (props) => {
                                    const { data, removeProps } = props;
                                    return (
                                      <components.MultiValue {...props}>
                                        <div
                                          style={{
                                            display: 'flex',
                                            alignItems: 'center',
                                            background: 'rgb(204, 204, 204)',
                                            borderRadius: '9999px',
                                            gap: '6px',
                                          }}
                                        >
                                          <img
                                            src={data.image || defaultImage}
                                            alt="user"
                                            style={{ width: 23, height: 23, borderRadius: '50%' }}
                                          />
                                          <span
                                            title={data.label}
                                            style={{
                                              maxWidth: 80,
                                              overflow: 'hidden',
                                              textOverflow: 'ellipsis',
                                              whiteSpace: 'nowrap',
                                              color: '#000',
                                            }}
                                          >
                                            {data.label.length > 15 ? `${data.label.slice(0, 15)}...` : data.label}
                                          </span>
                                          <span
                                            {...removeProps}
                                            
                                            style={{
                                              cursor: 'pointer',
                                              fontWeight: 'bold',
                                              marginLeft: 4,
                                              color: '#000',
                                              position: 'relative',
                                              width: '23px',
                                              height: '23px',
                                              display: 'flex',
                                              justifyContent: 'center',
                                              alignItems: 'center',
                                              borderRadius: '50%',
                                              transition: 'background-color 0.2s ease',
                                            }}
                                            onMouseEnter={(e) => (e.currentTarget.style.backgroundColor = 'rgb(255, 88, 93)')}
                                            onMouseLeave={(e) => (e.currentTarget.style.backgroundColor = 'transparent')}
                                          >
                                            ×
                                          </span>
                                        </div>
                                      </components.MultiValue>
                                    );
                                  },
                                  DropdownIndicator: () => null,
                                  IndicatorSeparator: () => null
                                }}
                              />
                            </div>
                          </div>
                        )}


                        {tabState !== 'pending-approvals' && tabState !== 'resubmission' && (
                          <div className="col-12 col-lg-3">
                            <div className="form-group">
                              <label htmlFor="statusSelect" className="fontTitle">
                                Status
                              </label>
                              
                               <select className="form-control form-select" id="statusSelect" value={status} onChange={handleStatusChange}>
                                  <option value="">&nbsp;&nbsp;Status</option>
                                  <option value="approved">&nbsp;&nbsp;Approved</option>
                                  <option value="cancelled">&nbsp;&nbsp;Cancelled</option>
                                  <option value="draft">&nbsp;&nbsp;Draft</option>
                                  <option value="pending">&nbsp;&nbsp;Pending</option>
                                  <option value="request for amendment">&nbsp;&nbsp;Pending for Resubmission</option>
                                  <option value="rejected">&nbsp;&nbsp;Rejected</option>
                                  <option value="submitted">&nbsp;&nbsp;Submitted</option>
                           </select>
                            </div>
                          </div>
                        )}

                      {tabState == 'allrequests'  && loggedinuser.roles.toLowerCase().includes("super") && (
                         <div className="col-12 col-lg-3">
                         <div className="form-group">
                           <label htmlFor="statusSelect" className="fontTitle">
                             Company Code
                           </label>
                              {/* <input
                                  type="text"
                                  id="companySearch"
                                  className="form-control"
                                  placeholder="Company Code"
                                  value={company}
                                  onChange={(e) => handleCompanies(e, setCompany)}
                                /> */}
                                 <select id="requestorId" className="form-control form-select" onChange={(e) => handleCompanies(e, setCompany)} value={company}>
                              <option value="0">&nbsp;&nbsp;Company Code</option>
                              {dataCompanies?.map((app) => (
                                <option key={app.id} value={app.id}>
                                  &nbsp;&nbsp;{app.name}
                                </option>
                              ))}
                            </select>
                         </div>
                       </div>
                       
                        )}

                        <div className="col-12 col-lg-3">
                          <div className="form-group position-relative">
                            <label htmlFor="exampleFormControlInput1" className="fontTitle">
                              Submitted Date From
                            </label>
                            <div className="date-picker-wrapper">
                              <DatePicker
                                selected={selectedDate}
                                onChange={(date) => {
                                  setSelectedDate(date);
                                  // Reset toDate when fromDate changes to a later date
                                  if (toDate && date > toDate) {
                                    setSelectedToDate(null);
                                  }
                                }}
                                placeholderText="From Date"
                                customInput={<CustomDateInput placeholder="From Date" />}
                                  dateFormat="dd-MMM-yyyy"
                                //maxDate={new Date()} // Optional: Can't select future dates
                              />
                            </div>
                          </div>
                        </div>
                        <div className="col-12 col-lg-3">
                          <div className="form-group position-relative">
                            <label htmlFor="exampleFormControlInput1" className="fontTitle" >
                              Submitted Date To
                            </label>
                            <div className="date-picker-wrapper">
                              <DatePicker
                                selected={toDate}
                                className="form-control"
                                onChange={(date) => setSelectedToDate(date)}
                                placeholderText="To Date"
                                 dateFormat="dd-MMM-yyyy"
                                customInput={<CustomDateInput placeholder="To Date" />}
                                minDate={selectedDate} // Disable dates before fromDate
                                //maxDate={new Date()} // Optional: Can't select future dates
                                disabled={!selectedDate} // Disable until fromDate is selected
                                filterDate={(date) => {
                                  // Additional filtering if needed
                                  return selectedDate ? date >= selectedDate : true;
                                }}
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="form-btn pos-ablt">
                        <button type="button" className="btn btn-dark" onClick={() => handleReset(tabState)}>
                          Reset
                        </button>

                        <button
                          type="button"
                          id="btn-filter"
                          className="btn btn-dark ww" 
                          onClick={() => handleFilter(tabState,searchQuery)}
                        >
                          Filter Search
                        </button>
                      </div>
                    </form>
               
                  </div>
                </div>
              </div>
              )}
            </div> 
          </div>

          <div className="sam-table">
            <div style={{ float: 'right' }}>
          <a href="#" className="float-right" onClick={(e) => { e.preventDefault(); handleDownloadExcel(); }}>

             {!loadingExcel ? (
            <img src={XLS} alt="Download Excel" className="img-fluid" data-themekey="#" />
            ) : (
          <div className="loader-container-excel">
         <div className="excel-loader"></div>
         </div>
        )}
          </a>
            </div>

            <div id="myPendingApprover-table_wrapper" className="dataTables_wrapper no-footer">
                <div className="dataTables_length" style={{ display: "none" }}></div>
              <div id="myPendingApprover-table_filter" className="dataTables_filter" style={{ display: 'none' }}>
                <label>Search:<input type="search" className="" placeholder="" aria-controls="myPendingApprover-table" /></label>
              </div>
              <div>
                <div className="row mb-3">
                  <div className="col-md-6 col-12">
                    <div className="entries-selector">
                      <span htmlFor="entries-select">Show</span>
                      <select
                        id="entries-select"
                        value={recordsPerPage}
                        onChange={(e) => handleChange(e)}
                        className="form-select"
                      >
                          <option value={10}>10</option>
                          <option value={25}>25</option>
                          <option value={50}>50</option>
                          <option value={100}>100</option>
                      </select>
                      <span>entries</span>
                    </div>
                  </div>
                </div>

      <div className="table-responsive">
      {loading ? (
        <div className="loader-container">
          <div className="loader"></div>
        </div>
      ) : (
        <table className="display dataTable no-footer subtypes-table table-hover table table-striped " id={id}   ref={tableRef}>
          <thead>
            <tr>
  {Object.keys(
    data[0] || 
    (tabState === "allrequests"
      ? {
          Id: "",
          RequestId: "",
          Application: "",
          Subtype: "",
          Requester: "",
          Status: "",
          CompanyCode: "",
          SubmittedDate: "",
          Subject: "",
        }
      : {})
  )
    .filter((key) => !key.startsWith("_"))
    .slice(1)
    .map((key, index) => (
      <th key={index} onClick={() => handleSort(key)}>
        {key.replace(/([A-Z])/g, " $1")
            .replace("Request Id", "Request ID")
            .trim()}{" "}
        {sortColumn === key && (sortOrder === "asc" ? "▲" : "▼")}
      </th>
    ))}
</tr>
          </thead>
          <tbody>
            {filteredData.length === 0 ? (
              <tr>
                 <td
        colSpan={
          tabState === "allrequests"
            ? 8
            : Object.keys(data[0] || {}).filter((key) => !key.startsWith("_")).length - 1
        }
        className="text-center"
      >
        No data available in table
      </td>
              </tr>
            ) : (
              filteredData.map((item, rowIndex) => {
                const reqId = String(Object.values(item)[0]);
                return (
                  <tr key={rowIndex} className={rowIndex % 2 === 0 ? "odd" : "even"}>
                    {Object.keys(item)
                      .filter((key) => !key.startsWith("_"))
                      .slice(1)
                      .map((key, colIndex) => {
                        const cellValue = item[key] || "";
                        const isSubject = key === "Subject";

                        // Valid CSSProperties with typings
                        const style: React.CSSProperties = isSubject
                          ? {
                              maxWidth: "200px",
                              minWidth: "200px",
                              textOverflow: "ellipsis",
                              whiteSpace: "pre-wrap",
                              overflowWrap: "anywhere",
                              textAlign:"left"
                            }
                          : key === "SubmittedDate"
                          ? { whiteSpace: "nowrap" }
                          : {};

                        return (
                          <td
                            key={colIndex}
                            className="table-content"
                            style={style}
                            title={isSubject && cellValue.length > maxChars ? cellValue : undefined}
                          >
                            {isSubject
                              ? cellValue.length > maxChars
                                ? getTruncatedText(cellValue, maxChars)
                                : cellValue
                              : key === linkColumn && getHeading() !== "All Requests"
                              ? (
                                  <a
                                    className="requestId"
                                    href={`${(() => {
                                      let targetPath = "/";
                                      switch (tabState) {
                                        case "resubmission":
                                        case "drafts":
                                          targetPath = "/pendingRequests";
                                          break;
                                        case "myrequest":
                                        case "reviews":
                                        case "actioned":
                                        case "allrequests":
                                          targetPath = "/readRequests";
                                          break;
                                        default:
                                          targetPath = "/readRequests";
                                          break;
                                      }
                                      return `${targetPath}?fetchingId=${reqId}&tab=${getHeading()}&urlheading=${getMainHeading()}&page=${currentPage}&size=${recordsPerPage}`;
                                    })()}`}
                                    onClick={(e) => {
                                      if (e.ctrlKey || e.metaKey || e.button === 1) return;
                                      e.preventDefault();

                                      let targetPath = "/";
                                      switch (tabState) {
                                        case "resubmission":
                                        case "drafts":
                                          targetPath = "/pendingRequests";
                                          break;
                                        case "myrequest":
                                        case "reviews":
                                        case "actioned":
                                        case "allrequests":
                                          targetPath = "/readRequests";
                                          break;
                                        default:
                                          targetPath = "/readRequests";
                                          break;
                                      }
                                      navigate(targetPath, {
                                        state: {
                                          fetchingId: reqId,
                                          tab: getHeading(),
                                          urlheading: getMainHeading(),
                                          page: currentPage,
                                          size: recordsPerPage
                                        },
                                      });
                                    }}
                                    rel="noopener noreferrer"
                                  >
                                    {cellValue && cellValue.trim() !== "" ? cellValue : "\u2014"}
                                  </a>
                                )
                              : key === "Status" && cellValue === "Request for amendment"
                              ? "Pending for Resubmission"
                              : cellValue && cellValue.trim() !== "" ? cellValue : "\u2014"}
                          </td>
                        );
                      })}
                  </tr>
                );
              })
            )}
          </tbody>
        </table>
      )}
    </div>

                <div className="pagination-container mt-4">
  <div className="pagination">
    {/* Previous Button */}
    <button
      disabled={currentPage === 1}
      onClick={() => handlePageChangeLocal(currentPage - 1)}
      className="pagination-btn"
    >
      <i className="fa fa-angle-double-left"></i>
    </button>

    {/* Page Numbers */}
    {renderPageNumbers().map((pageNum, index) =>
      pageNum === "..." ? (
        <button disabled className="pagination-btn dotsDisable">
        <span key={index} className="pagination-dots">...</span>
        </button>
      ) : (
        <button
          key={index}
          onClick={() => handlePageChangeLocal(pageNum as number)}
          className={`pagination-btn ${pageNum === currentPage ? "active" : ""}`}
        >
          {pageNum}
        </button>
      )
    )}

    {/* Next Button */}
    <button
      disabled={currentPage === totalPage}
      onClick={() => handlePageChangeLocal(currentPage + 1)}
      className="pagination-btn"
    >
      <i className="fa fa-angle-double-right"></i>
    </button>
  </div>
</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    );
  }
);

// -------------------------
// EXPORT MUST BE OUTSIDE
// -------------------------
export default DynamicTable;